module.exports = __webpack_public_path__ + "components/flag/static/square/ad-7b413486452eefd3b91568554d57d474.svg";